import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { RankDashboardDataT, LeadershipRankDefinitionT, SalesRankDefinitionT, RankHistoryEntryT } from "./types";

export type LeadershipRanksReduxStateT = {
  leadershipRanks: {
    rankDashboard: RankDashboardDataT;
    leadershipRankDefinitions: LeadershipRankDefinitionT[];
    salesRankDefinitions: SalesRankDefinitionT[];
    rankHistory: RankHistoryEntryT[];
    leadershipRankModalRank: number | null;
    salesRankModalRank: number | null;
  };
};

const initialState: LeadershipRanksReduxStateT = {
  leadershipRanks: {
    rankDashboard: {
      brv90: null,
      brvDeficit: null,
      brvPct: null,
      consistency: {
        rate: null,
        consecutiveMonths: 0,
        projectedNextMonth: null,
      },
      consecutiveMonths: 0,
      projectedNextMonth: null,
      rate: null,
      daysAtRank: 0,
      differentialRate: 0,
      highestRank: 0,
      highestRankTitle: "",
      keyPeople: [],
      leadershipPriorities: [],
      maxGeneration: 0,
      nextDifferentialRate: 0,
      nextGeneration: 0,
      nextRank: {
        rank: 0,
        title: "",
        prvThreshold: 0,
        brvThreshold: 0,
        maxGenerationDepth: 0,
        differentialPpw: 0,
        advancementBonusAmount: 0,
        ldBonusAmount: 0,
        consistencyPct: 0,
        qualifiedLeadersJson: [],
      },
      nextRankUnlocks: {
        maxGeneration: 0,
        differentialRate: 0,
        rankAdvancementBonus: 0,
        leadershipDevelopmentBonus: 0,
        consistencyBonusRate: null,
      },
      consistencyBonusRate: null,
      leadershipDevelopmentBonus: 0,
      overallProgress: 0,
      prv90: null,
      prvDeficit: null,
      prvPct: null,
      qlCount: 0,
      qlPct: 0,
      qlRequired: 0,
      qlSummary: {},
      rank: 0,
      rankAdvancementBonus: 0,
      rankSince: "",
      rankTitle: "",
      salesRank: {
        nextRank: {
          percent: 0,
          prvThreshold: 0,
          rank: 0,
          title: "",
        },
        percent: 0,
        prv90: "",
        prvProgressPct: 0,
        rank: 0,
        title: "",
      },
      teamProgress: [],
      pipelineProjects: [],
    },
    leadershipRankDefinitions: [],
    salesRankDefinitions: [],
    rankHistory: [],
    leadershipRankModalRank: null,
    salesRankModalRank: null,
  },
};

export const leadershipRanksSlice = createSlice({
  name: "leadershipRanks",
  initialState,
  reducers: {
    setLeadershipRankModalRank: (state, action: PayloadAction<number | null>) => {
      state.leadershipRanks.leadershipRankModalRank = action.payload;
    },
    setSalesRankModalRank: (state, action: PayloadAction<number | null>) => {
      state.leadershipRanks.salesRankModalRank = action.payload;
    },
  },
  selectors: {
    selectLeadershipRankModalRank: (state) => state.leadershipRanks.leadershipRankModalRank,
    selectSalesRankModalRank: (state) => state.leadershipRanks.salesRankModalRank,
  },
});

export const { setLeadershipRankModalRank, setSalesRankModalRank } = leadershipRanksSlice.actions;
export const { leadershipRanks: leadershipRanksInitialState } = initialState;
export const { selectLeadershipRankModalRank, selectSalesRankModalRank } = leadershipRanksSlice.selectors;
